module.exports = __webpack_public_path__ + "img/Invasion-PRCA_SpatialResearch.b77ee68c.png";